import { Flex, Text, UnstyledButton } from "@mantine/core";

import styles from "./AddressNotFound.module.css";

type AddressNotFoundProps = { onAddAddressManually: () => void };

export const AddressNotFound = ({ onAddAddressManually }: AddressNotFoundProps) => {
    return (
        <Flex className={`${styles.container} ${styles.fade}`}>
            <Text className={styles.text}>{`Don\u2019t see the address?`}</Text>
            <UnstyledButton pl="3xs" onClick={onAddAddressManually}>
                <Text className={styles.linkText}>Add it manually</Text>
            </UnstyledButton>
        </Flex>
    );
};
